import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Checkbox, TableSortLabel, Grid, Typography } from "@mui/material";
import DeletePopUp from "../../../../shared_elements/components/DeletePopUp";
import { LeasesMenuList, LeasesNav } from "../../../elements";
import { AmendmentList, AmendmentCRU } from "../components";
import { useParams } from "react-router-dom";
import { deleteAmendmentsApi, getAmendmentsApi } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { globalGetService, globalDeleteService } from "../../../../utils/globalApiServices";
import { enqueueSnackbar } from "notistack";
import { ButtonLoader, ShowAttachments } from "../../../../shared_elements/components";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from "../../../elements/LeasesBasicDetails";
import { trackActivity } from "../../../../utils/mixpanel";
import { isMobile } from "react-device-detect";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from "react-redux";
import { getStorage } from "../../../../shared_elements/actionCreators";
import FileUploadLayout from "../../../../shared_elements/components/FileUploadLayout";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import fileUpload, { getApiResponse } from "../../../../utils/fileUpload";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const AmendmentHd = ({ bulk, item, createSortHandler, toggleBulkOps, sortInfo }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Amendment`, page_type: page_type, })
  }
  const tableSorting = (key, name) => {
    return (
      <TableSortLabel
        active={sortInfo.sort_by === key ? true : false}
        direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
        onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
        sx={{ whiteSpace: "nowrap" }}
      >
        {name}
      </TableSortLabel>
    )

  }

  return (
    <TableHead>
      <TableRow>
        <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "amendment", operationType: ['D'] }}>
            <Checkbox disableRipple color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
          </PermissionWrapper>
          Action(s)
        </TableCell>
        <TableCell sx={{minWidth: '110px'}}>{tableSorting('date', 'Amendment Date')}</TableCell>
        <TableCell sx={{minWidth: '120px'}}>{tableSorting('unique_identifier', 'Amendment Number')}</TableCell>
        <TableCell sx={{minWidth: '120px'}}>{tableSorting('description', 'Amendment Desc', true)}</TableCell>
        <TableCell sx={{minWidth: '120px'}}>{tableSorting('tsn', 'TSN')}</TableCell>
        <TableCell sx={{minWidth: '120px'}}>{tableSorting('csn', 'CSN')}</TableCell>
      </TableRow>
    </TableHead>
  );
};

const Amendment = () => {
  const params = useParams();
  const dispatch = useDispatch()
  const {fileUploadDetails} = useSelector((state) => state.leases);
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [amendmentInfo, setAmendmentInfo] = useState({ list: [], pagination: {} });
  const [addEditAmendment, setAddEditAmendment] = useState({ mode: '', modal: false, data: null });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const [deleteAmendments, setDeleteAmendments] = useState({ modal: false, data: null, })
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
  const[isExport,seIsExport]=useState(false)
  const[uploadFileProgressData,setUploadFileProgressData]=useState({})
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  const [slug,setSlug]=useState({})


  useEffect(() => {
    const uploadedFileData = getApiResponse("Parties", slug);
    getAmendmentList('skeletonLoader', { per_page: 50 });
    trackActivity('Page Viewed',{ page_title: 'Amendment'})
    setUploadFileProgressData({uploadedFileData});
  }, []);

  const getAmendmentList = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getAmendmentsApi(params, query))
      .then(response => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        if (checkApiStatus(response)) {
          setAmendmentInfo(response.data.data);
        }
      })
    dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"amendment"}))
  }

  const deleteAmendmentFn = () => {
    setLoading(true);
    const idsToDelete = deleteAmendments?.modal && deleteAmendments?.data?.id ? [deleteAmendments?.data?.id] : (bulk?.ids || []).map(item => item?.id);
    globalDeleteService(deleteAmendmentsApi(params),
      { ids: idsToDelete }
    )
      .then(response => {
        if (checkApiStatus(response)) {
          getAmendmentList('fetch', { per_page: 50 });
          // setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Amendment`, success_msg: response?.data?.message, item_ids: deleteAmendments?.data|| bulk?.ids, response: response?.data })
          setBulk({ modal: false, ids: [], title: '', type: '' });
          setDeleteAmendments({ modal: false, data: null });
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Amendment`, error_msg: response?.data?.message, item_ids: deleteAmendments?.data|| bulk?.ids, response: response?.data })
        }
      })
  }

  const onDeteAttchments = (deltedslug) => {
    setAttachments({
      ...attachments, data: {
        ...attachments.data,
        attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
      }
    });
    if (addEditAmendment?.modal) {
      setAddEditAmendment({
        ...addEditAmendment,
        data: {
          ...addEditAmendment.data,
          attachments: addEditAmendment.data.attachments.filter(item => item?.slug !== deltedslug)
        }
      })
    }
    getAmendmentList('', { per_page: 50 });
  }

  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
    }
  }

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' }
    }
    setSortInfo(sortQuery)
    getAmendmentList('', { ...sortQuery, per_page: amendmentInfo?.pagination?.per_page });
  }
  const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "amendment",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getAmendmentList("fetch", { per_page: amendmentInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }

  const handleExport = () => {
    let query = { export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
    seIsExport(true);
    globalGetService(getAmendmentsApi(params, query)).then((response) => {
      if (checkApiStatus(response)) {
        enqueueSnackbar(
          response?.data.message,
          { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
        );
        seIsExport(false);
      }
    })
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Amendment`, page_type: page_type, })
  }

  return (
    <>
      <LeasesBasicDetails/>
      <Paper className="lease-details-section section-overflow lease-module-paper" elevation={0}>
        <LeasesNav type='basic'/>
        <div className="lease-details-content contnet-overflow">
          <Paper square className="responsive-paper">
            <Grid container className="responsive-grid" alignItems='flex-end'>
              <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                <LeasesMenuList btnText="Amendment" type="basic" />
              </Grid>
              <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                <BackToLeaseList />
              </Grid>
              <Grid item size={{ md: 6, xs: 12 }}>
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                  <li className="lease-mobile-button revision-history" ><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                  {
                    bulk?.type && bulk?.ids?.length ?
                      <>
                        <li className='lease-mobile-button'>
                          <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                        </li>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "amendment", operationType: ['D'] }}>
                          <li className='lease-mobile-button'>
                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                          </li>
                        </PermissionWrapper>
                      </> : null
                  }
                  {amendmentInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                  <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "amendment", operationType: ['C'] }}>
                    <li className='lease-mobile-button'>
                      <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditAmendment({ modal: true, data: { date: null, unique_identifier: '', description: "", tsn: "", csn: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }}>Add Amendment</Button>
                    </li>
                  </PermissionWrapper>
                </ul>
              </Grid>
            </Grid>
          </Paper>
          <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: amendmentInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
            <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
              {skeletonLoader ? <STableLoader count={4} rowCount={isMobile ? 10 : 11} /> : (
                <Table className="mui-table-format" stickyHeader>
                  <AmendmentHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={amendmentInfo?.list} toggleBulkOps={toggleBulkOps} />
                  <TableBody>
                    {amendmentInfo?.list?.length > 0 && amendmentInfo?.list?.map((item, index) =>{
                           const uploadedFileData = getApiResponse("amendment", item?.slug);

                    return (
                        <AmendmentList
                          slug={slug?.slug}
                          uploadedFileData={uploadedFileData }
                          uploadFileProgressData={uploadFileProgressData}
                          viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                          key={index}
                          item={item}
                          bulk={bulk}
                          viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                          onEditFn={() => setAddEditAmendment({ modal: true, data: item, mode: 'edit' })}
                          onView={() => setAddEditAmendment({ modal: true, data: item, mode: 'view' })}
                          onDeleteEolFn={() => {setDeleteAmendments({ modal: true, data: item, }); setBulk({ modal: false, ids: [item], title: '', type: '' });}}
                          toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                          onOpenAttachments={() => setAttachments({ modal: true, data: item })} />
                      )
                    }
                    )}
                  </TableBody>
                </Table>
              )}
              {!skeletonLoader && !amendmentInfo?.list?.length && <NoRecordFound />}
            </div>
            <Paper square>
              <Pagination
                 pagination={amendmentInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getAmendmentList("Pageloader", { page: pageNum, per_page: amendmentInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getAmendmentList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
              />
            </Paper>
          </Paper>
        </div>
      </Paper>
        {addEditAmendment.modal &&
          <AmendmentCRU
            fileUpload={handleUpload}
            addEditAmendment={addEditAmendment}
            modeType={addEditAmendment?.mode}
            getResponseBack={() => {getAmendmentList('fetch', { per_page: amendmentInfo.pagination.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
            onOpenAttachments={() => setAttachments({ modal: true, data: addEditAmendment?.data, mode:'view' })}
            onToggleModal={() => setAddEditAmendment({ modal: false, data: null, mode: '' })}
          />
        }
        {deleteAmendments.modal &&
          <DeletePopUp
            modal={deleteAmendments.modal}
            title='Delete Amendment'
            content={`Are you sure, you want to Delete?`}
            onToggleModal={() => {
              setDeleteAmendments({ modal: false, data: null });
              setBulk({ modal: false, ids: [], title: '', type: '' });
            }}
            onDeleteRecords={() => deleteAmendmentFn()}
          />}
        {attachments.modal ?
          <ShowAttachments
            moduleName="Amendment"
            url='delete-attachment'
            attachmentsData={attachments}
            getResponseBack={onDeteAttchments}
            toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
            onViewDisabled={addEditAmendment?.mode === 'view' || attachments?.mode==='view'}
            permissionKey='amendment'
          /> : null
        }
        {bulk.modal ?
          <DeletePopUp
            modal={bulk.modal}
            title={`Delete ${bulk?.type === "bulk" && bulk?.ids?.length > 0 && bulk?.ids?.length === (amendmentInfo?.list?.length || 0) ? "All Amendments" : "Selected Amendments"}`}
            onDeleteRecords={() => deleteAmendmentFn()}
            content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
            onToggleModal={() => setBulk({ modal: false, ids: [], type: '' })}
          /> : null
        }
           <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
       {
          revisionHistory.modal &&  
          <RevisionHistory 
            moduleName={"amendment"}
            revisionHistory={revisionHistory}
            onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          />
        }
        {isLoading ? <PageLoader /> : null}
    </>
  );
};
export default RoleBaseAccess(Amendment, { application: 'lease_revamp', feature: 'amendment', operationType: ['R'] });

